import { render } from "./ImportGrid.vue?vue&type=template&id=64643960"
import script from "./ImportGrid.vue?vue&type=script&lang=js"
export * from "./ImportGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__